import BreadCrumb from "../common/breadcrumb";
import SEO from "../../data/seo";
import HeaderTwo from "../../layout/headers/header-two";
import CompanyHistory from "./history";
import FooterTwo from "../../layout/footers/footer-two";

const History = () => {
    return (
        <>
            <SEO pageTitle="Company History"/>
            <HeaderTwo/>
            <BreadCrumb title="Company History"    items={[
                { label: "Company History" },
            ]}/>
            <CompanyHistory/>
            <FooterTwo/>
        </>
    );
};

export default History;